import sift from '@services/sift';
import { fetchAuthSession } from 'aws-amplify/auth';
import { v4 as uuidv4 } from 'uuid';
import session from './session';

const SECURITY_SESSION_ID = 'security-session-id';

function identify({
  userId,
  sessionId = window.sessionStorage.getItem(SECURITY_SESSION_ID) ?? '',
}: {
  userId: string;
  sessionId?: string;
}) {
  sift.setUser(userId, sessionId);
}

async function start() {
  try {
    if (!session.get()) return;
    const amplifySession = await fetchAuthSession();
    if (amplifySession) {
      identify({ userId: session.get()?.investorId ?? '' });
    }
  } catch (err: any) {
    // noop
  }
}

function trackPageView() {
  sift.trackPageView();
}

let hasInitialized = false;
export default (() => {
  if (!hasInitialized) {
    sift; // (default export is an iife that calls the necessary initialization methods required to use sift downstream)
    if (!window.sessionStorage.getItem(SECURITY_SESSION_ID))
      window.sessionStorage.setItem(SECURITY_SESSION_ID, uuidv4());
    hasInitialized = true;
  }
  return {
    identify,
    start,
    trackPageView,
  };
})();
